import Slider from "react-slick";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import SearchHome from "./search-home";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveConvergenceCarouselSlides } from "../../redux/slice/convergence-carousel-slides-slice";
import { RootState, useAppDispatch } from "../../redux/store";

var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };

const HeroSlider = () => {
    const { data } = useSelector(
        (state: RootState) => state.convergenceCarouselSlides
    );

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(retrieveConvergenceCarouselSlides());
    }, [dispatch]);
    // TODO: Fix API response schema and integrate the data

    return (
        <div className="placeholder hero-slider">
            <div className="container-fluid waterfall hero">
                <div className="gallery js-flickity flickity-enabled">
                    <div className="flickity-viewport">
                        <div className="flickity-slider">
                        <Slider {...settings}>
                                {/* customLeftArrow={<LeftArrow />} customRightArrow={<RightArrow />} */}
                                {data.map((CarouselItem, index) => {
                                    return (
                                      <div className="img-gradient" key={index}>
                                        <Link to={CarouselItem.linkUrl} >
                                            <img src={CarouselItem.image} alt={CarouselItem.type} />
                                        </Link>
                                      </div>  
                                    );
                                })}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            <SearchHome />
        </div>
    );
};

export default HeroSlider;
